import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {ITableColRowStyle} from '../../../../../incase-domain/elements/staticTable';
import ColorSelectCompact from '../../../../../incase-domain/components/select/compact/color/colorSelectCompact/ColorSelectCompact';
import DebouncedNumberInput from '../../common/debounced/DebounceNumberInput';

interface SegmentDialogProps {
    styles: Record<string, ITableColRowStyle>;
    styleDialog: {index: number; show: boolean};
    highlightedElementChangeHandler: (styling: unknown) => void;
}
function SegmentDialog(props: SegmentDialogProps): ReactElement {
    const {styles, styleDialog, highlightedElementChangeHandler} = props;

    const {t} = useTranslation();

    return (
        <div className="l-group--form">
            <div className="l-group__item u-flex u-h-between u-v-center">
                <ColorSelectCompact
                    label={t('presEditPage.editSidebar.elements.tableModal.cellColor')}
                    color={styleDialog.index === -1 ? '' : (((styles || {})[styleDialog.index.toString()] || {}).color as string)}
                    onChange={(color) => {
                        const newColumnStyle = {...styles};
                        newColumnStyle[styleDialog.index.toString()] = {
                            ...newColumnStyle[styleDialog.index.toString()],
                            color: color || '',
                        };
                        highlightedElementChangeHandler(newColumnStyle);
                    }}
                />
            </div>

            <div className="l-group__item u-flex u-h-between u-v-center">
                <ColorSelectCompact
                    label={t('presEditPage.editSidebar.elements.tableModal.fontColor')}
                    color={styleDialog.index === -1 ? '' : (((styles || {})[styleDialog.index.toString()] || {}).fontColor as string)}
                    onChange={(color) => {
                        const newColumnStyle = {...styles};
                        newColumnStyle[styleDialog.index.toString()] = {
                            ...newColumnStyle[styleDialog.index.toString()],
                            fontColor: color || '',
                        };
                        highlightedElementChangeHandler(newColumnStyle);
                    }}
                />
            </div>

            <div className="l-group__item u-flex u-h-between u-v-center">
                <ColorSelectCompact
                    label={t('presEditPage.editSidebar.elements.tableModal.borderColor')}
                    color={styleDialog.index === -1 ? '' : (((styles || {})[styleDialog.index.toString()] || {}).borderColor as string)}
                    onChange={(color) => {
                        const newColumnStyle = {...styles};
                        newColumnStyle[styleDialog.index.toString()] = {
                            ...newColumnStyle[styleDialog.index.toString()],
                            borderColor: color || '',
                        };
                        highlightedElementChangeHandler(newColumnStyle);
                    }}
                />
            </div>

            <div className="l-group__item">
                <DebouncedNumberInput
                    label={t('designSidepanel.fontSize')}
                    step={0.1}
                    min={0.1}
                    onChange={(newValue) => {
                        const newColumnStyle = {...styles};
                        newColumnStyle[styleDialog.index.toString()] = {
                            ...newColumnStyle[styleDialog.index.toString()],
                            fontSize: newValue,
                        };
                        highlightedElementChangeHandler(newColumnStyle);
                    }}
                    value={styleDialog.index === -1 ? 2 : (((styles || {})[styleDialog.index.toString()] || {}).fontSize as number) || 2}
                />
            </div>

            <div className="l-group__item">
                <DebouncedNumberInput
                    label={t('designSidepanel.borderSize')}
                    step={0.1}
                    min={0.1}
                    onChange={(newValue) => {
                        const newColumnStyle = {...styles};
                        newColumnStyle[styleDialog.index.toString()] = {
                            ...newColumnStyle[styleDialog.index.toString()],
                            borderSize: newValue,
                        };
                        highlightedElementChangeHandler(newColumnStyle);
                    }}
                    value={
                        styleDialog.index === -1 ? 0.1 : (((styles || {})[styleDialog.index.toString()] || {}).borderSize as number) || 0.1
                    }
                />
            </div>
        </div>
    );
}

export default SegmentDialog;
